<template>
  <div>
    <!-- <pre> {{localvalue}}</pre> -->
    <vs-card class="cstm_vx_card">
    
      <!-- {{ localvalue[0].child }} -->
      <div slot="header" class="flex flex-wrap justify-between items-center">
        <h5>Users</h5>
        <vs-button
          v-if="localvalue[0].child.user_type === 'Parent' && checkCreatePermission()"
          type="border"
          @click="addpopup = !addpopup"
        >
          Add
        </vs-button>
      </div>
      <div class="vx-row">
        <vs-table :data="localvalue" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="index">Index</vs-th>
            <vs-th style="min-width: 105px" sort-key="first_name"
              >Image</vs-th
            >
             <vs-th style="min-width: 165px" sort-key="first_name"
              >Full Name</vs-th
            >
             <vs-th style="min-width: 105px" sort-key="first_name"
              >First Name</vs-th
            >
            <vs-th style="min-width: 120px" sort-key="middle_name"
              >Middle Name</vs-th
            >
            <vs-th style="min-width: 105px" sort-key="last_name"
              >Last Name</vs-th
            >
            <vs-th style="min-width: 135px" sort-key="number"
              >Phone Number</vs-th
            >
            <vs-th style="min-width: 105px" sort-key="email">Email</vs-th>
            <vs-th style="min-width: 100px" sort-key="address1"
              >Address 1</vs-th
            >
            <vs-th style="min-width: 100px" sort-key="address2"
              >Address 2</vs-th
            >
            <vs-th style="min-width: 100px" sort-key="state">County/State</vs-th>
            <vs-th style="min-width: 100px" sort-key="city">City</vs-th>
            <vs-th style="min-width: 100px" sort-key="zip">Postcode/Zip</vs-th>
            <vs-th style="min-width: 100px" sort-key="country_name" 
              >Country</vs-th
            >
            <!-- <vs-th style="min-width: 100px" sort-key="active">Is Active</vs-th> -->
            <!-- <vs-th sort-key="created at">Created At</vs-th> -->
            <vs-th style="min-width: 100px" sort-key="action">Action</vs-th>
          </template>

          <template>
          =
            <vs-tr :key="indextr" v-for="(item, indextr) in localvalue">
              <vs-td :data="localvalue[indextr].first_name">
                {{ indextr + 1 }}
               <!-- <pre>{{item.child}}</pre>  -->
              </vs-td>
               <vs-td :data="localvalue[indextr].child.picture">
               <img v-if="localvalue[indextr].child.picture != ''" style="width: 25px; height: 25px; object-fit: contain;" class="person-img rounded-full shadow-md block" :src="localvalue[indextr].child.picture" />
        
        <svg v-else style="width: 25px; height: 25px; object-fit: contain;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle" class="svg-inline--fa fa-user-circle fa-w-16" role="img" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"/></svg>
              </vs-td> 
             <vs-td :data="localvalue[indextr].first_name">
                <span
                  class="cursor-pointer"
                  style="color: blue"
                  @click="
                    gotoChild(
                      localvalue[indextr].child
                        .client_users_id?localvalue[indextr].child
                        .client_users_id:localvalue[indextr].child
                        .id
                    )">
               {{ localvalue[indextr].child.first_name }} {{ localvalue[indextr].child.last_name }}
                 </span>
             </vs-td>
              <vs-td :data="localvalue[indextr].first_name">
               
                  {{ localvalue[indextr].child.first_name }}
              
              </vs-td>

              <vs-td :data="localvalue[indextr].child.middle_name">
                {{ localvalue[indextr].child.middle_name }}
              </vs-td>
              <vs-td :data="localvalue[indextr].child.last_name">
                {{ localvalue[indextr].child.last_name }}
              </vs-td>

              <vs-td :data="localvalue[indextr].child.mobile">
                {{ localvalue[indextr].child.mobile }}
              </vs-td>

              <vs-td :data="localvalue[indextr].child.email">
                {{ localvalue[indextr].child.email }}
              </vs-td>

              <vs-td
                :data="localvalue[indextr].address.address1"
              >
                {{ localvalue[indextr].address.address1 }}
              </vs-td>
              <vs-td
                :data="localvalue[indextr].address.address2"
              >
                {{ localvalue[indextr].address.address2 }}
              </vs-td>
              <vs-td
                :data="localvalue[indextr].address.state"
              >
                {{ localvalue[indextr].address.state }}
              </vs-td>
              <vs-td :data="localvalue[indextr].address.city">
                {{ localvalue[indextr].address.city }}
              </vs-td>
              <vs-td :data="localvalue[indextr].address.zip">
                {{ localvalue[indextr].address.zip }}
              </vs-td>
              <vs-td :data="localvalue[indextr].address" >
                {{

                  localvalue[indextr].address.platform_customer_countries_id?
                  getCountryName(localvalue[indextr].address.platform_customer_countries_id):'' }}

                <!-- {{ localvalue[indextr].child.address.platform_customer_countries_id?
                  getCountryName(localvalue[indextr].child.address.platform_customer_countries_id):''

                }} -->
              </vs-td>
              <!-- <vs-td :data="localvalue[indextr].child.active_user">
                {{
                  localvalue[indextr].child.active_user === "0" ? "No" : "Yes"
                }}
              </vs-td> -->
              <!-- 
              <vs-td :data="localvalue[indextr].child.address.address2">
                {{ localvalue[indextr].child.address.address2 }}
              </vs-td> -->
              <!-- <vs-td :data="localvalue[indextr].address.created_at">
                {{ localvalue[indextr].address.created_at|moment('MMM-YYYY') }}
              </vs-td> -->
              <vs-td :data="localvalue[indextr]">
                <div class="flex">
                  <toggle-button
                    :value="localvalue[indextr].child.active_user === '1'"
                    :color="{
                      checked: '#35C76F',
                      unchecked: '#EA5455',
                      disabled: '#CCCCCC',
                    }"
                    class="mt-3 mr-1"
                    @change="handleToggle(indextr)"
                  />
                  <vs-button
                  v-if="checkDeletePermission"
                    type="filled"
                    :disabled="localvalue[indextr].child.active_user === '1'"
                    @click="remove(indextr)"
                    icon="delete"
                    color="danger"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Do you want to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Add User"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add" v-if="addpopup">
        <vs-row>
        
          <vs-checkbox
            v-model="sameasparentAddress"
            @change="abc"
            class="custom_Input"
            value="same"
            style="width: 100%"
            >Same as Parent's Address</vs-checkbox
          >

          <vs-col
            :vs-xs="12"
            :vs-md="12"
            :vs-lg="12"
            class="p-2"
            v-for="childfield in staticChildFields"
            :key="childfield.id"
          >
         
           <label class="vs-input--label w-full"
              >{{ childfield.field_label
              }}<span v-if="childfield.enabled_child" class="required"></span
            ></label>
            <vs-input
              v-if="childfield.field_name != 'platform_customer_countries_id' && childfield.field_name != 'platform_timezone_id'"
              v-model="minor[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            
            />
            
             <v-select
                  v-else-if="childfield.field_name != 'platform_customer_countries_id' && childfield.field_name == 'platform_timezone_id'"
                  v-model="minor[childfield.field_name]"
                  v-validate="childfield.enabled_child == true ? 'required' : ''"
                  :reduce="(option) => option.timezone_id"
                  label="timezone"
                  :name="childfield.field_label"
                  :options="platformTimeZone"
                  style="width: 100%"

               icon-pack="feather"
              icon="icon-edit"
              icon-after
                />
            <v-select
              v-else
              v-model="minor[childfield.field_name]"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
             
              :reduce="(option) => option.id"
              label="country_name"
              :name="childfield.field_label"
              :options="countryList"
              style="width: 100%"
            />
            <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px;" v-if="childfield.field_label=='Phone'">
                <span style="font-size: 14px; margin-right: 2px;" class="material-icons-outlined">info</span>Country code is mandatory.
             </div>
            <span
              v-show="errors.has(`add.${childfield.field_label}`)"
              class="text-danger"
              >{{ errors.first(`add.${childfield.field_label}`) }}</span
            >
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleAddCancel"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import vSelect from 'vue-select'
import { createMinor, deleteClient, Clienttoogle } from '@/api/client'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  name: 'address',
   mixins: [PermissionMiddleware],
  components: {
    ToggleButton,
    vSelect
  },
  props: {
    checkDeletePermission:{
      required: true
    },
    countryList: {
      required: true,
      type: Array,
      default: () => []
    },
    platformTimeZone: {
      required: true,
      type: Array,
      default: () => []
    },
    value: {
      required: true,
      type: Array,
      default: () => []
    },
    parent_id: {
      required: true,
      type: Number
    },
    staticChildFields: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      sameasparentAddress: false,
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      minor: {
        first_name: null,
        middle_name: null,
        last_name: null,
        email: null,
        mobile: null,
        address1: null,
        address2: null,
        state: null,
        zip: null,
        city: null,
        platform_customer_countries_id: null
      },
      editIndex: null,
      deleteindex: false
    }
  },
  computed: {
    localvalue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },

  },

  methods: {
    getCountryName(countryId){
      const countryName = this.countryList.filter(item => {
        if(item.id = countryId){
          return item.country_name
        }
      })
      return countryName[0].country_name
    },
    abc () {
      if (this.sameasparentAddress === true) {
        this.minor.address1 = this.localvalue[0].address.address1
        this.minor.address2 = this.localvalue[0].address.address2
        this.minor.state = this.localvalue[0].address.state
        this.minor.zip = this.localvalue[0].address.zip
        this.minor.city = this.localvalue[0].address.city
        this.minor.platform_customer_countries_id =
          this.localvalue[0].address.platform_customer_countries_id
      }
    },
    handlechange (index) {
      this.localvalue.map((item) => {
        item.defaults = 0
      })
      this.localvalue[index].defaults = 1
    },
    async handleSave () {
      try {
      const result = this.$validator.validateAll('add')
        if (result) {
        const data= await createMinor(
            this.minor,
            this.parent_id,
            this.$store.getters.customerId
          )
           this.addpopup = false
              this.showSuccessMessage(
                'success',
                'User Added Successfully',
                'success'
              )
              const newClient = data.data.data.clientUser
              const child = newClient.basic_details
              child.client_user_address = newClient.basic_details.address
              child.active_user = '1'
              child.client_user_address.client_users_id =
                newClient.basic_details.client_users_id
              const __temp = {
                address: newClient.basic_details.address,
                child
              }
              this.$set(this.localvalue, this.localvalue.length, __temp)
              this.minor = {
                first_name: null,
                middle_name: null,
                last_name: null,
                email: null,
                mobile: null,
                address1: null,
                address2: null,
                state: null,
                city: null,
                zip: null,
                platform_customer_countries_id: null,
                platform_timezone_id:''
              }
             
            }
           
      } catch (api_error) {
        console.log(api_error)
         this.showSuccessMessage('Error', api_error.data.message, 'danger')
      //    for (const [key, value] of Object.entries(
      //           api_error.data.errors
      //         )) {
                
      // }
     
    }
    },
    handleAddCancel () {
      this.addpopup = false
      this.minor = {
        first_name: null,
        middle_name: null,
        last_name: null,
        email: null,
        mobile: null,
        address1: null,
        address2: null,
        state: null,
        city: null,
        zip: null,
        platform_customer_countries_id: null
      }
    },
    gotoChild (id) {
      this.$router.push({
        name: 'clients-user-details',
        params: { client_user_id: id }
      })
    },
    remove (index) {
      if (this.localvalue[index].child.active_user === '1') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Deactivate Account First',
          ...this.warnProp()
        })
      } else {
        this.deletepopup = true
        this.deleteindex = index
      }
    },
    async handleDelete () {
      let payload = {}
      try {
        if (
          this.localvalue[this.deleteindex].child.user_type === 'Parent' ||
          this.localvalue[this.deleteindex].child.user_type === 'Individual'
        ) {
          payload = {
            client_user_id: [
              this.localvalue[this.deleteindex].child.client_user_address
                .client_users_id
            ]
          }
             this.$router.push({ name: 'students' })
        } else {
          payload = {
            client_user_id: [
              this.localvalue[this.deleteindex].child.id
            ]
          }
        }
        const data = await deleteClient(payload,this.$store.getters.customerId)

        this.$vs.notify({
          title: 'Deleted',
          text: 'User deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

     
        /* const __temp = this.localvalue
        __temp.splice(this.deleteindex, 1)
        this.deletepopup = false */
      } catch (e) {}
    },
    async handleToggle (index) {
      try {
        const togglePayload = {
          active_user: this.localvalue[index].child.active_user === '1' ? 0 : 1,
          client_user_id:
            this.localvalue[index].child.client_users_id?this.localvalue[index].child.client_users_id:this.localvalue[index].child.id
        }
        const { data } = await Clienttoogle(togglePayload)
        this.$vs.notify({
          title: 'Success',
          text: `User ${
            togglePayload.active_user === 0 ? 'deactivated' : 'activated'
          } Successfully`,
          ...this.successProp()
        })
        // if (index === 0 && togglePayload.active_user === 0) {
        //   this.localvalue.map((item) => {
        //     item.child.active_user = 0
        //   })
        // }
        //
        this.localvalue[index].child.active_user =
          data.data.clientUser.basic_details.active_user
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e.data.message,
          ...this.warnProp()
        })
      }
    }
  },
  watch: {
    addpopup () {
      if (!this.addpopup) {
        this.handleAddCancel()
      }
    }
  }
  /* addpopup */
}
</script>
<style scoped>
.required:after {
  content: " *";
  color: red;
}
</style>